<script setup lang="ts"></script>

<template>
  <span class="relative text-bridgit-green">
    <slot />
  </span>
</template>
